import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
//primereact
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";
//components
import Panel from "../../../components/panel/panel";
import { FiltersPayment } from "./FiltersPayment";
import { TablePayment } from "./TablePayment";
import ModelReport from "../../../components/report/ModelReport";
//services
import { postReportPayment } from "../../../services/Report/postReportPayment";
//hooks
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
import usePermission from "../../../hooks/usePermission";

import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";

export const PaymentStatement = () => {
  const { control, formState, handleSubmit, getValues } = useForm();
  const { errors } = formState;
  const [selectedEnterprise, setSelectedEnterprise] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [toastId, setToastId] = useState(null);
    usePermission('272')


  const { enterprise, isLoadingEnterprises } = useOptionsSelect();

  const mutation = useMutation(postReportPayment, {
    onSuccess: (data) => {
      setReportData(data);
      toast.update(toastId, {
        render: "Relatório gerado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    },
    onError: () => {
      toast.update(toastId, {
        render: "O campo Número Ficha selecionado é inválido.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
    },
  });

const onSubmit = () => {
  if (!selectedEnterprise) {
    toast.warn("O campo Empreendimento é obrigatório!");
    return;
  }

  const sale_id = getValues("sale_id");
  if (!sale_id) {
    toast.warn("O campo Número Ficha é obrigatório!");
    return;
  }

  setReportData(null);
  setLoading(true);
  const id = toast.loading("Buscando relatório, aguarde...");
  setToastId(id);

  const payload = {
    sale_id: Number(sale_id),
    enterprise_id: selectedEnterprise,
  };

  mutation.mutate(payload, {
    onSuccess: (data) => {
      setReportData(data);
      toast.update(id, {
        render: "Relatório gerado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoading(false);
    },
    onError: () => {
      toast.update(id, {
        render: "Ocorreu um erro ao gerar o relatório.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
      setLoading(false);
    },
  });
};



  const handleExportPDF = () => {
    const element = document.getElementById("sales-summary-report");
    if (!element) return;

    const options = {
      margin: 10,
      filename: "Demonstrativo_Pagamento.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
    };

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        element.classList.remove("force-light");
      })
      .catch(() => {
        element.classList.remove("force-light");
      });
  };

  const handleExportExcel = () => {
    if (!reportData) return;
    const { installments } = reportData;
    const mainColumns = [
      "Ano",
      "Nº",
      "Descrição",
      "Vencimento",
      "Valor Orig.",
      "Pago",
      "Dt. Pag",
      "Correção",
      "Multa",
      "Juros",
      "Acrés.",
      "Desc.",
      "Desc. Ant",
      "Método"
    ];
    const allInstallments = installments
      ? installments.flatMap((yearData) =>
          yearData.installments.map((installment) => ({
            Ano: yearData.year,
            "Nº": installment.number,
            Descrição: installment.description,
            Vencimento: installment.due_date,
            "Valor Orig.": installment.value,
            Pago: installment.paid_value,
            "Dt. Pag": installment.payment_date,
            Correção: installment.correction,
            Multa: installment.fine,
            Juros: installment.interest,
            "Acrés.": installment.addition,
            "Desc.": installment.discount,
            "Desc. Ant": installment.advance_discount,
            Método: installment.payment_method
          }))
        )
      : [];
    const MAX_CELL_LENGTH = 32767;
    const safeRows = allInstallments.map((row) => {
      const safeRow = {};
      mainColumns.forEach((col) => {
        let value = row[col];
        if (typeof value === "string" && value.length > MAX_CELL_LENGTH) {
          value = value.substring(0, MAX_CELL_LENGTH - 3) + "...";
        }
        safeRow[col] = value;
      });
      return safeRow;
    });
    const ws = XLSX.utils.json_to_sheet(safeRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ParcelasPagas");
    XLSX.writeFile(wb, "parcelas-pagas.xlsx");
  };


  const items = [
    {
      template: () => (
        <Link to={"/reports/payment-statement"} className="p-breadcrumb-link">
          Extrato de Pagamento
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  return (
    <>
              <BreadCrumb
                model={items}
                home={home}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "16px",
                }}
              />
      <Panel title="Extrato de Pagamento" className="mb-4">
        <FiltersPayment
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          isLoadingEnterprises={isLoadingEnterprises}
          enterprise={enterprise}
          selectedEnterprise={selectedEnterprise}
          setSelectedEnterprise={setSelectedEnterprise}
          control={control}
          errors={errors}
          loading={loading}
        />
      </Panel>
      <div className="mt-5">
        {loading && (
          <Panel>
            <div className="mb-3">
              <Skeleton
                height={400}
                width="100%"
                className="mb-2"
              />
            </div>
          </Panel>
        )}
        {!loading && reportData && (
          <Panel>
            <div className="d-flex gap-2 mb-3 justify-content-end">
              <Button
                icon="fa fa-file-pdf"
                className="p-button-secondary cursor-pointer"
                rounded
                onClick={handleExportPDF}
              />
              <Button
                icon="fa fa-file-excel"
                className="p-button-success cursor-pointer"
                rounded
                onClick={handleExportExcel}
              />
            </div>
            <div id="sales-summary-report">
              <ModelReport
                title={
                  reportData.enterprise_title || "Extrato de Pagamento"
                }
                logo={reportData.enterprise_logo || "sem logo"}
                date={`Emitido em ${
                  reportData.report_info?.generated_at ||
                  new Date().toLocaleDateString("pt-BR")
                }`}
                madeBy={reportData?.report_info?.generated_by || ""}
               
              >
                <TablePayment
                  reportData={reportData}
                  columns={
                    reportData.columns || [
                      "Nº",
                      "Descrição",
                      "Vencimento",
                      "Valor Orig.",
                      "Pago",
                      "Método",
                    ]
                  }
                />
              </ModelReport>
            </div>
          </Panel>
        )}
      </div>
    </>
  );
};
